import styled from 'styled-components'
import { themeBreakPoints } from '@chegg-wt/core/theme/theme'

export const Container = styled.div`
  padding: 1px 0;
  text-align: center;
  max-width: 836px; // 900 - padding
  margin: 0 auto;
`

export const CardsContainer = styled.div`
  display: flex;
  justify-content: center;
  @media (max-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    flex-wrap: wrap;
  }
  padding-bottom: 16px;

  // Creates a gap between cards. Moves gap from side to top on small screen
  & > * + * {
    margin-left: 12px;

    @media (max-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
      margin-top: 12px;
      margin-left: 0;
    }
  }
`
